import React from 'react'
import {Flipped} from 'react-flip-toolkit'
import {Product} from '../../../../util/cart'
import {useTranslation} from '../../../../util/i18n'
import {style} from '../../../../util/style'
import {Theme} from '../../../Theme'
import {CardTitle} from '../../../ui/Card'
import {ProductImage} from '../../layout/product/ProductImage'
import {ProductType, ProductVariationType} from '../../pages'
import './CartProduct.scss'
import {
	CartProductVariant,
	CartProductVariants,
	CartProductVariantType
} from './CartProductVariants'

const styles = style('cartproduct', ['container', 'preview'])

export type ProductCartType = ProductType & {
	cartVariations: Array<ProductVariationType>
	productVariants: Array<Product>
}

export const CartProductPreview: React.FC<ProductCartType> = ({
	cartVariations,
	variations,
	productVariants,
	...product
}) => {
	const {url, title, preview, quantity_discount: discounts, id} = product
	const hasDiscounts = discounts?.length > 0 && discounts[0].quantity
	const t = useTranslation('webshop').cart

	return (
		<Flipped inverseFlipId={'product_flipper_' + id} scale>
			<div className={styles.preview()}>
				<a href={url} className={styles.preview('image')}>
					<ProductImage {...preview} />
				</a>
				<div className={styles.preview('info')}>
					<CardTitle
						className={styles.preview('info-title')}
						theme={Theme.H5}
						as="h3"
						title={preview?.title || title}
					/>
					{preview && preview.text && (
						<p className={styles.preview('info-text')}>
							<Theme.Wysiwyg>{preview.text}</Theme.Wysiwyg>
						</p>
					)}
					{hasDiscounts && (
						<div className={styles.preview('info-discounts')}>
							<div className={styles.preview('info-discounts-title')}>
								{t.quantity_discount}
							</div>
							{discounts.map(
								({price_per_piece: p, quantity: q}) =>
									p &&
									q && (
										<div
											className={styles.preview('info-discounts-discount')}
										>{`€${p} ${t.from} ${q} ${t.pieces}`}</div>
									)
							)}
						</div>
					)}
				</div>
			</div>
		</Flipped>
	)
}

export const CartProductContainer: React.FC = ({children}) => {
	return <div className={styles.container}>{children}</div>
}

export const CartProductFlipped: React.FC<
	ProductCartType & {
		flippedProps?: any
		uniqueKey?: string
	}
> = (props) => (
	<Flipped flipId={'product_flipper_' + props.uniqueKey}>
		{(flippedProps) => {
			return <CartProduct flippedProps={flippedProps} {...props} />
		}}
	</Flipped>
)

export const CartProductVariantFlipped: React.FC<
	CartProductVariantType & {
		flippedProps?: any
	}
> = (props) => (
	<Flipped flipId={props.uniqueKey.replace(/[\W_]+/g, '')}>
		{(flippedProps) => {
			return <CartProductVariant flippedProps={flippedProps} {...props} />
		}}
	</Flipped>
)

export const CartProductCollapse: React.FC = ({children}) => {
	return <div>{children}</div>
}

export const CartProduct: React.FC<
	ProductCartType & {
		flippedProps?: any
	}
> = ({variations, productVariants, flippedProps, ...productDetails}) => {
	return (
		<div className={styles()} {...flippedProps}>
			<div className={styles('row')}>
				<CartProductPreview
					productVariants={productVariants}
					{...productDetails}
				/>
				<CartProductVariants
					productVariants={productVariants}
					variations={variations}
					{...productDetails}
				/>
			</div>
		</div>
	)
}
